// extracted by mini-css-extract-plugin
module.exports =  {"tc-enumeration":"Enumeration-module__tc-enumeration___IPdfx"};